import { api } from './api.js';

/**
 * ehr#736 (Jay 10-31): "Don't let anyone delete anything from the chart. They can archive only."
 * One place for the chart lists' Archive / Restore calls and their "Show archived" list URLs, so no
 * chart list calls DELETE. (The API answers DELETE on a chart item with 405 ARCHIVE_ONLY.)
 */
export type ChartItem =
  | { kind: 'note'; contactId: string; id: string }
  | { kind: 'file'; id: string }
  | { kind: 'form'; contactId: string; id: string }
  | { kind: 'task'; id: string }
  | { kind: 'taskNote'; taskId: string; id: string };

export function chartItemPath(item: ChartItem): string {
  switch (item.kind) {
    case 'note':
      return `/contacts/${item.contactId}/notes/${item.id}`;
    case 'file':
      return `/files/${item.id}`;
    case 'form':
      return `/contacts/${item.contactId}/form-submissions/${item.id}`;
    case 'task':
      return `/tasks/${item.id}`;
    case 'taskNote':
      return `/tasks/${item.taskId}/notes/${item.id}`;
  }
}

/** Archive: the item leaves its list (Show archived lists it). Nothing is deleted. */
export const archiveItem = (item: ChartItem) => api.post(`${chartItemPath(item)}/archive`);

/** Restore: an archived item goes back on its list as it was. */
export const restoreItem = (item: ChartItem) => api.post(`${chartItemPath(item)}/restore`);

/** A list's URL for its archived items (`?archived=1`), keeping any query it already has. */
export const archivedUrl = (listUrl: string) =>
  `${listUrl}${listUrl.includes('?') ? '&' : '?'}archived=1`;
